import PrivateRoute from '../../components/PrivateRoute'

// Pages
import BillPage from '../../pages/Faturamento/faturar/BillPage'
import CreateBillPage from '../../pages/Faturamento/faturar/CreateBillPage'
import DetailsBillPage from '../../pages/Faturamento/faturar/DetailsBillPage'
import EditBillPage from '../../pages/Faturamento/faturar/EditBillPage'
import PackingList from '../../pages/Faturamento/romaneios/PackingList'

const RoutesFaturamento = {
  billing: [
    {
      path: '/faturamento/faturar',
      element: <PrivateRoute element={BillPage} />,
    },
    {
      path: '/faturamento/criar',
      element: <PrivateRoute element={CreateBillPage} />,
    },
    {
      path: '/faturamento/:id/detalhes',
      element: <PrivateRoute element={DetailsBillPage} />,
    },
    {
      path: '/faturamento/:id/editar',
      element: <PrivateRoute element={EditBillPage} />,
    },
  ],
  packingList: [
    {
      path: '/faturamento/romaneios',
      element: <PrivateRoute element={PackingList} />,
    },
  ],
}

export default RoutesFaturamento
